module.exports = __webpack_public_path__ + "static/img/direct.be6088e2.png";